import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Col = styled.col<{ width: string | number; bordered?: boolean }>(props => ({
    borderRight: props.bordered ? theme(props).tables.border.solid : undefined,
    width: props.width,
}));
